import { useContext, Context } from 'react';

export function useStateContext<T>(arg: Context<T>): T {
    const context = useContext(arg);
    if (context === undefined) {
        throw new Error('useStateContext must be used within a Provider');
    }
    return context;
}
